<template>
  <el-select
    class="inputWidth"
    :value="showValue"
    :placeholder="placeholder || $t('search.choose')"
    :multiple="multiple"
    :clearable="clearable"
    :filterable="filterable || true"
    :disabled="disabled"
    @change="change"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item[labelKey]"
      :value="item[valueKey]"
    ></el-option>
  </el-select>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Object],
        default: '',
      },
      apiUrl: {
        type: String,
        default: '',
      },
      apiData: {
        type: Object,
        default: () => {},
      },
      placeholder: {
        type: String,
        default: '',
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      filterable: {
        type: Boolean,
        default: false,
      },
      dataString: {
        // 请求回来的数据层级
        type: String,
        default: 'data',
      },
      valueKey: {
        // 展示value key
        type: String,
        default: 'value',
      },
      labelKey: {
        // 展示label key
        type: String,
        default: 'label',
      },
      method: {
        // 请求方法
        type: String,
        default: 'post',
      },
      disabled: {
        //知否置灰
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        options: [],
      };
    },
    computed: {
      showValue() {
        return typeof this.value === 'object'
          ? this.value
            ? this.value[this.valueKey]
            : ''
          : this.value;
      },
    },
    mounted() {
      this.getOptions();
    },
    watch: {
      apiUrl() {
        this.getOptions();
      },
    },
    methods: {
      getOptions() {
        if (!this.apiUrl) return;
        const dataString = this.dataString.split('.');
        const method = this.method;
        this.$axios[method](this.apiUrl, this.apiData).then((res) => {
          if (res.data.code === 0) {
            let returnData = res.data;
            let options = [];
            dataString.forEach((item) => {
              returnData = returnData[item];
              options = returnData;
            });
            this.options = options;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      change(value) {
        if (this.value && typeof this.value === 'object') {
          // 如果是对象，回传对象
          let obj = {};
          obj = this.options.find((item) => {
            return item[this.valueKey] === value; //筛选出匹配数据
          });
          this.$emit('input', obj);
          this.$emit('change', obj);
        } else {
          this.$emit('input', value);
          this.$emit('change', value, this.options);
        }
      },
    },
  };
</script>
